// Update your index.js to use React 17 rendering method
import React from 'react';
import ReactDOM from 'react-dom'; // Not react-dom/client
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Replace createRoot usage with render
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
